module.exports = __webpack_public_path__ + "img/spain-cardiovascular-diseases-female.a87b7201.png";